export const backendURL = 'https://sgostu-backend.download';
